export default __webpack_public_path__ + "static/media/tree.04893f79.jpg";